import { render, staticRenderFns } from "./ui-likes-editor.vue?vue&type=template&id=45e35647&scoped=true&"
import script from "./ui-likes-editor.vue?vue&type=script&lang=js&"
export * from "./ui-likes-editor.vue?vue&type=script&lang=js&"
import style0 from "./ui-likes-editor.vue?vue&type=style&index=0&id=45e35647&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e35647",
  null
  
)

export default component.exports